import * as tslib_1 from "tslib";
import { ShaderBase, GL_MaterialPassBase } from "@awayjs/stage";
/**
 * GL_DepthMaterial forms an abstract base class for the default shaded materials provided by Stage,
 * using material methods to define their appearance.
 */
var GL_DepthMaterial = (function (_super) {
    tslib_1.__extends(GL_DepthMaterial, _super);
    /**
     *
     * @param pool
     * @param surface
     * @param elementsClass
     * @param stage
     */
    function GL_DepthMaterial(material, materialPool) {
        var _this = _super.call(this, material, materialPool) || this;
        _this._shader = new ShaderBase(materialPool.elementsClass, _this, _this._stage);
        _this._pAddPass(_this);
        return _this;
    }
    GL_DepthMaterial.prototype.invalidate = function () {
        _super.prototype.invalidate.call(this);
        this._textureVO = this._material.getTextureAt(0) ? this._shader.getAbstraction(this._material.getTextureAt(0)) : null;
    };
    GL_DepthMaterial.prototype._includeDependencies = function (shader) {
        _super.prototype._includeDependencies.call(this, shader);
        shader.projectionDependencies++;
        if (shader.alphaThreshold > 0)
            shader.uvDependencies++;
    };
    GL_DepthMaterial.prototype._initConstantData = function (shader) {
        _super.prototype._initConstantData.call(this, shader);
        var index = this._fragmentConstantsIndex;
        var data = shader.fragmentConstantData;
        data[index] = 1.0;
        data[index + 1] = 255.0;
        data[index + 2] = 65025.0;
        data[index + 3] = 16581375.0;
        data[index + 4] = 1.0 / 255.0;
        data[index + 5] = 1.0 / 255.0;
        data[index + 6] = 1.0 / 255.0;
        data[index + 7] = 0.0;
    };
    /**
     * @inheritDoc
     */
    GL_DepthMaterial.prototype._getFragmentCode = function (registerCache, sharedRegisters) {
        var code = "";
        var targetReg = sharedRegisters.shadedTarget;
        var dataReg1 = registerCache.getFreeFragmentConstant();
        var dataReg2 = registerCache.getFreeFragmentConstant();
        this._fragmentConstantsIndex = dataReg1.index * 4;
        var temp1 = registerCache.getFreeFragmentVectorTemp();
        registerCache.addFragmentTempUsages(temp1, 1);
        var temp2 = registerCache.getFreeFragmentVectorTemp();
        registerCache.addFragmentTempUsages(temp2, 1);
        code += "div " + temp1 + ", " + sharedRegisters.projectionFragment + ", " + sharedRegisters.projectionFragment + ".w\n" +
            "mul " + temp1 + ", " + dataReg1 + ", " + temp1 + ".z\n" +
            "frc " + temp1 + ", " + temp1 + "\n" +
            "mul " + temp2 + ", " + temp1 + ".yzww, " + dataReg2 + "\n";
        //codeF += "mov ft1.w, fc1.w	\n" +
        //    "mov ft0.w, fc0.x	\n";
        if (this._textureVO && this._shader.alphaThreshold > 0) {
            var albedo = registerCache.getFreeFragmentVectorTemp();
            code += this._textureVO._getFragmentCode(albedo, registerCache, sharedRegisters, sharedRegisters.uvVarying);
            var cutOffReg = registerCache.getFreeFragmentConstant();
            code += "sub " + albedo + ".w, " + albedo + ".w, " + cutOffReg + ".x\n" +
                "kil " + albedo + ".w\n";
        }
        code += "sub " + targetReg + ", " + temp1 + ", " + temp2 + "\n";
        registerCache.removeFragmentTempUsage(temp1);
        registerCache.removeFragmentTempUsage(temp2);
        return code;
    };
    /**
     * @inheritDoc
     */
    GL_DepthMaterial.prototype._activate = function (projection) {
        _super.prototype._activate.call(this, projection);
        if (this._textureVO && this._shader.alphaThreshold > 0) {
            this._textureVO.activate();
            this._shader.fragmentConstantData[this._fragmentConstantsIndex + 8] = this._shader.alphaThreshold;
        }
    };
    return GL_DepthMaterial;
}(GL_MaterialPassBase));
export { GL_DepthMaterial };



// WEBPACK FOOTER //
// ../dist/lib/materials/GL_DepthMaterial.js